import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomerBankAccountSetupService {

  constructor(private http:HttpClient) { }

  customerBankAccountSetupForm: FormGroup = new FormGroup(
    {
      acountHolderName: new FormControl(''),
      bankAccountNumber: new FormControl(''),
      bankRoutingNumber: new FormControl(''),
      bankAccountType: new FormControl(''),
      bankstreet: new FormControl(''),
      bankcity: new FormControl(''),
      bankstate: new FormControl(''),
      bankzipcode: new FormControl(''),
      contactName: new FormControl(''),
      bankPhone: new FormControl(''),
    }
  )
}
